import DraggableScrollDiv from "../../components/draggableScroll/DraggableScrollDiv";
import {DragDropForm} from "../../components/form/DragDropForm";
import {useMedia} from "../../hooks";
import {useEffect, useImperativeHandle, useRef, useState} from "react";

export default function ArticleMobilePreview({article, handleSubmitRef}) {
    const {media, createMedia, deleteMedia} = useMedia("food/articles/", article?._id);
    const [files, setFiles] = useState({});
    const changed = useRef([]);

    useImperativeHandle(handleSubmitRef, () => ({
        submit() {
            handleSubmit();
        }
    }));

    function handleSubmit() {
        for (let key of Object.keys(media)) {
            if (!files[key]) {
                // Delete
                deleteMedia(article?._id, key);
            }
        }
        for (let [key, file] of Object.entries(files)) {
            if (media[key]) {
                deleteMedia(article?._id, key);
            }
            // Post
            fileToDataURL(file)
        }
    }

    function changeCallback(newFiles, name) {
        // Existing file changed need to do put instead of create/delete
        if (Object.keys(media).includes(name) && Object.keys(newFiles).includes(name)) {
            changed.current?.push(name);
        }
        setFiles(newFiles);
    }

    function fileToDataURL(file, filename = "") {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            createMedia(article?._id, reader.result, filename);
        };/*
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };*/
    }


    function dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type: mime});
    }

    useEffect(() => {
        if(media) {
            let newFiles = {};
            for (let [key, base64] of Object.entries(media)) {
                let file = dataURLtoFile('data:image/png;base64,' + base64, 'a.png');
                newFiles[key] = file;
            }
            setFiles(newFiles);
        }
    }, [media])

    return <div>
        <h1>{article?.name}</h1>

        <DraggableScrollDiv className={"mobile-preview m-t-20"} horizontal={true}>
            {media ? <DragDropForm className={"horizontal"} fileTypes={["JPG", "PNG", "GIF"]} onChange={changeCallback}
                           value={files} width={"360px"} height={"250px"}/>
            : <Loader/>}
        </DraggableScrollDiv>
        <p>
            {article?.description}
        </p>

    </div>
}


function Loader() {
    return <div style={{
        width: "360px", height: "250px",
        border: "2px solid rgba(152, 166, 173, 0.5)",
        borderRadius: "5px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "grey",
    }} className={"status loading"}>
        <div className="icon loader-1 center"><span></span></div>
    </div>
}